import {ActionTree} from "vuex";
import {RootState} from "../types/RootState";
import {FormModalState} from "../types/FormModalState";
import {FormModalElement} from "@service/types/FormModalElement";
import {EventBus} from "@common/EventBus";

const typesMap: Record<string, string> = {
    'meeting': 'program',
    'session': 'program',
    'catalog': 'partner'
}

const resetTabAfterClose = (item: FormModalElement) => {
    if (item.closeRoute == 'Home') {
        EventBus.$emit('resetTab', 'program');
    }
    if (item.closeRoute == 'Invites') {
        EventBus.$emit('resetTab', 'invites');
    }
}

export const actions: ActionTree<FormModalState, RootState> = {
    addElement({commit, state}, element: FormModalElement) {
        const newElements = state.elements.filter(item => {
            return item.id == element.id
                    || item.isLive
                    || element.closeRoute != item.closeRoute
                    || (typesMap[element.type] != typesMap[item.type]);
        })
        const elementIndex = newElements.findIndex(item => {
            return item.type == element.type && item.id == element.id
        })

        if (elementIndex >= 0) {
            if (newElements[elementIndex].closeRoute != element.closeRoute) {
                resetTabAfterClose(newElements[elementIndex]);
            }
            let newFields: any = {state: 'full'};

            newElements[elementIndex] =  Object.assign({}, state.elements[elementIndex], newFields);
        }
        else {
            newElements.push(element);
        }

        commit('setElements', newElements);
    },
    removeElement({commit, state}, element: FormModalElement) {
        const indexToDelete = state.elements.findIndex(item => {
            return item.type == element.type && item.id == element.id
        })
        if (indexToDelete >= 0) {
            commit('deleteElement', indexToDelete);
        }
    },
    removeByElementId({commit, state}, id) {
        const indexToDelete = state.elements.findIndex(item => {
            return item.id == id
        })
        if (indexToDelete >= 0) {
            commit('deleteElement', indexToDelete);
        }
    },
    setIsLive({commit, state}, {element, isLive}: any) {
        const index = state.elements.findIndex(item => {
            return item.type == element.type && item.id == element.id
        });
        if (index >= 0) {
            commit('seIsLive', {
                index, isLive
            });
            if (isLive) {
                const elementToRemove = state.elements.findIndex(item => {
                    return item.id != element.id && item.isLive;
                })
                if (elementToRemove >= 0) {
                    EventBus.$emit('minimizedClosed', Object.assign({}, state.elements[elementToRemove]));
                    if (state.elements[index].closeRoute != state.elements[elementToRemove].closeRoute) {
                        resetTabAfterClose(state.elements[elementToRemove]);
                    }
                    commit('deleteElement', elementToRemove);
                }
            }

        }
    },
    minimize({commit, state}) {
        const ids = state.elements
            .filter(item => {
                return item.state != 'minimized' && item.isLive
            })
            .map(item => {
                return item.id
            });
        if (ids.length) {
            commit('minimize', ids);
        }
    },
    fullScreen({commit}, item: FormModalElement) {
        commit('fullScreen', [item.id]);
    },
    normalize({commit}, item: FormModalElement) {
        commit('normalize', [item.id]);
    },
    setState({commit, state}, {item, newState}) {
        if (newState == 'full') {
            const newElements = state.elements.filter((element: any) => {
                return !(element.state == 'full' && element.id != item.id && element.closeRoute == item.closeRoute);
            })
            commit('setElements', newElements);
        }
        commit('setState', {
            ids: [item.id],
            newState: newState
        });
    }
};

